import React from "react";

import SmartImage from "../../../components/SmartImage";
import { PinIcon, StarIcon } from "../../home/components/SupplierListCard";
import { formatPriceLabel } from "../../search/suppliersMappers";

export const BookmarkToggle = ({ saved, pending, name, onToggle }) => (
  <button
    type="button"
    className={`sv-save${saved ? " is-saved" : ""}${pending ? " is-pending" : ""}`}
    disabled={pending}
    aria-pressed={saved}
    aria-busy={pending}
    aria-label={saved ? `Remove ${name} from saved` : `Save ${name}`}
    onClick={onToggle}
  >
    {pending ? (
      <span className="sv-save-spinner" aria-hidden="true" />
    ) : (
      <svg viewBox="0 0 20 20" aria-hidden="true">
        <path d="M5 2.5h10a1 1 0 0 1 1 1v14l-6-3.6-6 3.6v-14a1 1 0 0 1 1-1Z" />
      </svg>
    )}
  </button>
);

const SupplierGridCard = ({ supplier, saved, pending, onOpen, onToggleSave }) => (
  <li className="acc-card sv-card">
    <button type="button" className="acc-card-button" onClick={() => onOpen(supplier)}>
      <span className="acc-card-media">
        {supplier.logoUrl ? (
          <SmartImage src={supplier.logoUrl} alt="" aspectRatio="286 / 230" />
        ) : (
          <span className="sv-card-initial" aria-hidden="true">
            {supplier.name.charAt(0).toUpperCase()}
          </span>
        )}

        {!supplier.online && <span className="acc-badge">Offline</span>}
      </span>

      <span className="acc-card-body">
        <span className="acc-card-name">{supplier.name}</span>

        {supplier.totalRatings > 0 && (
          <span className="sv-card-rating">
            <StarIcon />
            {supplier.rating.toFixed(1)}
            <i>({supplier.totalRatings.toLocaleString()})</i>
          </span>
        )}

        <span className="acc-card-facts">
          {supplier.addressLine && (
            <span className="sv-card-meta">
              <PinIcon />
              <span>{supplier.addressLine}</span>
            </span>
          )}

          {supplier.pricePerKg !== null && (
            <span className="acc-card-price">
              <i>from</i>
              <b>{formatPriceLabel(supplier.pricePerKg, supplier.currency)}</b>
              <i>/kg</i>
            </span>
          )}
        </span>
      </span>
    </button>

    <BookmarkToggle
      saved={saved}
      pending={pending}
      name={supplier.name}
      onToggle={() => onToggleSave(supplier)}
    />
  </li>
);

export default React.memo(SupplierGridCard);
